var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profiles__component profile-list"},[_c('div',{staticClass:"profiles__component-content"},[_c('ritm-tree',{attrs:{"show-tools":"","no-sort":"","no-counter":"","no-animations":"","tree-data":_vm.profilesList,"icon-by-item":_vm.iconByItem,"node-click":_vm.nodeClick,"tool-click":_vm.toolClick,"tool-kit":_vm.toolKitByItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }